// extracted by mini-css-extract-plugin
module.exports = {"content":"verify-lkpp-view__content___yWYdR"};